import { WidgetDef } from '../../../types';

/**
 * Canonical widgets for the `home` page. Each `widgetId` is the stable id used
 * by `AccountCustomization#content.widgets.home[].widgetId` in upstack_api.
 *
 * Cross-repo coupling: when adding/renaming/removing a widget here, mirror the
 * change in upstack_api at `app/models/account_customization.rb`
 * (`AccountCustomization::WIDGET_CATALOG["home"]`) and bump the count assertion
 * in `spec/models/account_customization_spec.rb`. The MCP customization tools
 * advertise this list via their `tools/list` input schemas. See `docs/mcp.md`
 * in upstack_api for the protocol.
 */
export const HomeWidgetDefs: WidgetDef[] = [
  { widgetId: 'upcomingExpirations', headerName: 'Upcoming Expirations', index: 0, hide: false, disabled: false },
  {
    widgetId: 'status',
    headerName: 'Status',
    index: 1,
    hide: false,
    disabled: false
  },
  { widgetId: 'locations', headerName: 'Locations', index: 2, hide: false, disabled: false },
  { widgetId: 'cases', headerName: 'Cases', index: 3, hide: false, disabled: false },
  { widgetId: 'suppliers', headerName: 'Top Suppliers', index: 4, hide: false, disabled: false }
];
